import request from "@/utils/request";

const state = {
    userInfo: {},
    profile: {
        nickname: '',
        gender: '',
        birthday: '',
        address: '',
        bio: ''
    }
}

const mutations = {
    SET_USER_INFO(state, userInfo) {
        state.userInfo = {  ...userInfo }
    },
    UPDATE_USER_INFO(state, updateInfo) {
        state.userInfo = {  ...state.userInfo, ...updateInfo }
    },
    SET_PROFILE(state, profile) {
        state.profile = { ...state.profile, ...profile }
    },
    UPDATE_AVATAR(state, avatar) {
        state.userInfo.avatar = avatar
    },
    SET_VERIFICATION_STATUS(state, status) {
        state.userInfo.isVerified = status
    },
    SET_MERCHANT_STATUS(state, status) {
        state.userInfo.isMerchant = status
    },
    CLEAR_USER_INFO(state) {
        state.userInfo = {
            id: '',
            username: '',
            email: '',
            phone: '',
            avatar: '',
            realName: '',
            idCard: '',
            wechat: '',
            qq: '',
            isVerified: false,
            isMerchant: false,
            createTime: '',
            lastLoginTime: ''
        }
        state.profile = {
            nickname: '',
            gender: '',
            birthday: '',
            address: '',
            bio: ''
        }
    }
}

const actions = {
    // 获取用户信息
    async getUserInfo({ commit }) {
        try {
            // 这里调用API获取用户信息
            const res = await request.get('/front/profile/getUserInfo')
            if (res.code == 200) {
                commit('SET_USER_INFO', res.data)
            }
            // console.log(res)
            return res
        } catch (error) {
            console.error('获取用户信息失败:', error)
            throw error
        }
    },

    // 更新用户信息
    async updateUserInfo({ commit }, userInfo) {
        try {
            const response = await request.put('/api/user/info', userInfo)
            if (response.data.success) {
                commit('SET_USER_INFO', userInfo)
            }
            return response.data
        } catch (error) {
            console.error('更新用户信息失败:', error)
            throw error
        }
    },

    // 实名认证
    async submitVerification({ commit }, verificationData) {
        try {
            const response = await request.post('/api/user/verification', verificationData)
            if (response.data.success) {
                commit('SET_VERIFICATION_STATUS', true)
            }
            return response.data
        } catch (error) {
            console.error('实名认证失败:', error)
            throw error
        }
    },

    // 申请成为商家
    async applyMerchant({ commit }, merchantData) {
        try {
            const response = await request.post('/api/user/merchant', merchantData)
            if (response.data.success) {
                commit('SET_MERCHANT_STATUS', true)
            }
            return response.data
        } catch (error) {
            console.error('申请商家失败:', error)
            throw error
        }
    }
}

const getters = {
    isLoggedIn: state => state.userInfo.isLoggedIn,
    userDisplayName: state => state.userInfo.realName || state.userInfo.username || state.profile.nickname,
    isVerified: state => state.userInfo.isVerified,
    isMerchant: state => state.userInfo.isMerchant,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}